import { createRoot } from "react-dom/client";
import { StrictMode } from "react";
import { Home } from "./routes/Home";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Movie } from "./routes/Movie";
import { Series } from "./routes/Series";
import "./index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry(failureCount, error) {
        if (failureCount >= 3) return false;
        if (error instanceof Error && error.message.includes("contrase"))
          return false;
        return true;
      },
    },
  },
});

const elem = document.getElementById("root")!;

document.addEventListener("DOMContentLoaded", async () => {
  const searchParams = new URLSearchParams(location.search);
  if (searchParams.get("password")) {
    const res = await fetch("/login", {
      method: "POST",
      body: JSON.stringify({ password: searchParams.get("password") }),
    });
    if (res.ok) {
      searchParams.delete("password");
      location.search = searchParams.toString();
    } else {
      alert("Invalid password");
    }
  }
});

const app = (
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/series" element={<Home />} />
          <Route path="/movies/:id" element={<Movie />} />
          <Route path="/series/:id" element={<Series />}>
            <Route path="episode/:season/:episode" element={<Series />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>
);

if (import.meta.hot) {
  // With hot module reloading, `import.meta.hot.data` is persisted.
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(app);
} else {
  // The hot module reloading API is not available in production.
  createRoot(elem).render(app);
}
